import { z } from "zod/v4";

import { HistoryActionList, HistoryDtoSchema } from "../../../dtos/history";

export const PostHistoryRequestBodySchema = z.object({
  experienceId: z.uuid(),
  action: z.enum(HistoryActionList),
});
export type PostHistoryRequestBodyType = z.infer<
  typeof PostHistoryRequestBodySchema
>;

export const PostHistoryResponseBodySchema = z.object({
  history: HistoryDtoSchema.array(),
});
export type PostHistoryResponseBodyType = z.infer<
  typeof PostHistoryResponseBodySchema
>;
